export default __webpack_public_path__ + "static/media/img_match_apply_nudge.f1cb6cf8.png";